<app-content-modal class="total-vacations-detail-modal" [hideClose]="false">
  <div class="row total-vacations-detail-modal__title">
    <div class="col">
      <h1 class="u-h4">{{ 'MOT.VACATIONS.DETAIL.TITLE' | translate }}</h1>
    </div>
  </div>
  <app-total-vacations-detail></app-total-vacations-detail>
</app-content-modal>
